export default __webpack_public_path__ + "static/media/cs-c003-boss-right.4f1e4338.svg";